export const addSubproductIdToURL = subproductId => {
  const url = new URL(window.location.href);
  url.searchParams.set('id', subproductId);
  window.history.pushState(null, '', url.toString());
};
